module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-01-c1c1a9372526063a881e57b49c03695f.svg";